import {
  labelSmall
} from "./chunk.GAOIIZQS.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/form-control/form-control-standard.styles.ts
var form_control_standard_styles_default = r` /* Label */ .form-control--standard .form-control__label { font-family: var(--sl-font-sans); display: block; margin-bottom: 0.625rem; color: var(--sl-input-placeholder-color); font-weight: var(--sl-font-weight-semibold); ${labelSmall} } .form-control--standard .form-control__control-host > input, .form-control--standard .form-control__control-host > select, .form-control--standard .form-control__control { padding: 0 var(--form-control-floating-label-left); line-height: calc(var(--form-control-min-height) - var(--form-control-border-width) * 2); } /* Help text */ .form-control--standard.form-control--has-help-text .form-control__help-text { margin: 0.375rem 0 0 var(--form-control-floating-label-left); } `;

export {
  form_control_standard_styles_default
};
